export default __webpack_public_path__ + "images/logo.svg?c39117654b352625a920c7bb145aadf1";